import styled from '@emotion/styled'

export const WarningText = styled.div`
  font-family: Satoshi;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
`
